import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

export default function MapView({ center, markers = [], height = 260 }) {
  const ref = useRef(null);
  const mapRef = useRef(null);
  const layerRef = useRef(null);
  const markersKey = JSON.stringify(markers.map((m) => [m.lat, m.lng, m.label]));

  useEffect(() => {
    if (!center) return undefined;
    if (!mapRef.current) {
      mapRef.current = L.map(ref.current, { zoomControl: true }).setView(center, 13);
      L.tileLayer("https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png", {
        attribution: "© OpenStreetMap © CARTO", maxZoom: 19,
      }).addTo(mapRef.current);
      layerRef.current = L.layerGroup().addTo(mapRef.current);
    } else {
      mapRef.current.setView(center);
    }
    layerRef.current.clearLayers();
    markers.forEach((m) => {
      const c = L.circleMarker([m.lat, m.lng], {
        radius: 9, color: m.color || "#f97316", weight: 2,
        fillColor: m.color || "#f97316", fillOpacity: 0.8,
      }).addTo(layerRef.current);
      if (m.label) c.bindPopup(m.label);
    });
    return undefined;
  }, [center, markersKey]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => () => { mapRef.current?.remove(); mapRef.current = null; }, []);

  if (!center) return null;
  return <div ref={ref} data-testid="map-view" style={{ height }} className="rounded-xl border border-white/10 overflow-hidden relative z-0" />;
}
